import TextField from "@mui/material/TextField";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type TextInputProps = {} & Omit<FormInputProps, "formLayout">;

export const TextInput: React.FC<TextInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolvedValue = (): string => {
    const e = formData[formItem.name];
    if (!e) return "";
    else return e as string;
  };
  return (
    <div className="_text-input.tsx text-input">
      <TextField
        id={formItem.name}
        value={resolvedValue()}
        onChange={(evt) => setValue(evt.target.value)}
        disabled={formItem.disabled}
        variant="outlined"
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
        fullWidth
      />
    </div>
  );
};
